export const deleteAccount = {
  deleteAccountTitle: "Solicitar eliminar cuenta en Randrush",
  deleteAccountContent: "Si deseas eliminar tu cuenta en Randrush, por favor envía un correo a",
  deleteAccountInfo: "Nuestro equipo tomara alrededor de 24 horas para resolver tu solicitud.",
  deleteAccountInfo2:
    "Al eliminar la cuenta, toda la informacion relacionada con tu cuenta será eliminada de forma permanente y no podrá volver a utilizar su cuenta nuevamente.",
};
